import React from 'react';
import { AnimateLoadedContent } from '../../../../../v2BaseComponents/Loader';
import { mainContentPadding } from '../../../../../v2BaseComponents/MainContentContainer';
import { View } from 'react-native';
import { useIsMobileLayout } from '../../../../../../hooks/useIsMobileLayout';
import AdministrationLogsTable from './AdministrationLogsTable';
import { useOrganizationEntityAuditLogs } from '../../../../../../hooks/api/useOrganizationEntityAuditLogs';

export type AdministrationLogsTabOwnProps = {};

export type AdministrationLogsTabProps = AdministrationLogsTabOwnProps;

const AdministrationLogsTab: React.FC<AdministrationLogsTabProps> = () => {
    const { isLoading, auditLogs } = useOrganizationEntityAuditLogs();

    const isMobile = useIsMobileLayout();
    return (
        <AnimateLoadedContent isLoading={isLoading}>
            {() => (
                <>
                    <View
                        style={{ width: '100%', height: '100%', paddingTop: isMobile ? undefined : mainContentPadding }}
                    >
                        <AdministrationLogsTable isLoading={isLoading} auditLogs={auditLogs} />
                    </View>
                </>
            )}
        </AnimateLoadedContent>
    );
};

export default React.memo(AdministrationLogsTab);
